module.exports = "https://trybtryb-legacy.web.app/img/digital-item.db82ed3b.svg";